export default __webpack_public_path__ + "static/video-f8f586d853f3b91debbe952faf6d4666.mp4";